// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AlertController from "./alert_controller.js"
application.register("alert", AlertController)

import ArticleEditorController from "./article_editor_controller.js"
application.register("article-editor", ArticleEditorController)

import AutosizeController from "./autosize_controller.js"
application.register("autosize", AutosizeController)

import ClipboardController from "./clipboard_controller.js"
application.register("clipboard", ClipboardController)

import DatetimepickerController from "./datetimepicker_controller.js"
application.register("datetimepicker", DatetimepickerController)

import DropdownController from "./dropdown_controller.js"
application.register("dropdown", DropdownController)

import TogglerController from "./toggler_controller.js"
application.register("toggler", TogglerController)
